 // Storage keys 
  export const getStoragekeysNegociations = 
    (nomeDoFiltro) => ({
      grupoProduto: `${nomeDoFiltro}-selectedProdutoSolicitacoes`,
      produto: `${nomeDoFiltro}-selectedProdutoUnicoSolicitacoes`,
      filiais: `${nomeDoFiltro}-selectedFilialSolicitacoes`,
      negociacao: `${nomeDoFiltro}-selectedNegociacaoSolicitacoes`,
      periodo: `${nomeDoFiltro}-selectedPeriodoSolicitacoes`,
      status: `${nomeDoFiltro}-selectedStatusSolicitacoes`,
      cliente: `${nomeDoFiltro}-selectedClienteSolicitacoes`,
      medida: `${nomeDoFiltro}-selectedMedidaSolicitacoes`,
    })
;

 export const getStoragekeysRules = 
    (nomeDoFiltro) => ({
      grupoProduto: `${nomeDoFiltro}-clienteGrupoProduto`,
      produto: `${nomeDoFiltro}-clienteProduto`,
      filiais: `${nomeDoFiltro}-clienteFilial`,
      micro: `${nomeDoFiltro}-clienteMicro`,
      cidade: `${nomeDoFiltro}-clienteCidade`,
      segmento: `${nomeDoFiltro}-clienteSegmento`,
      segmentoUnico: `${nomeDoFiltro}-clienteSegmentoUnico`,
      cluster: `${nomeDoFiltro}-clienteCluster`,
      familia: `${nomeDoFiltro}-clienteFamilia`,
      prazo: `${nomeDoFiltro}-clientePrazo`,
    })
;